import { each } from 'lodash-es';
import resize from '../helpers/resize';
import { createStore } from '../helpers/state';
const mqSizes = {
    narrowDesktopMaxWidth: '1150',
    tabletMaxWidth: '1024',
    tabletPortraitMaxWidth: '900',
    phoneMaxWidth: '740',
    phonePortraitMaxWidth: '420'
};
// const prefix = 'mq'
const initialState = {};
const match = {};
each(mqSizes, (size, k) => {
    const key = k.replace('MaxWidth', '');
    const _size = parseInt(size);
    initialState[key] = resize.width() < _size;
    match[key] = _size;
});
const mqStore = createStore(initialState);
resize.add({
    resize: () => {
        each(mqStore, (state, key) => {
            state.set(resize.width() < match[key]);
        });
    }
});
export default mqStore;
